import { buildOurStory } from "../sections";

document.addEventListener("DOMContentLoaded", () => {
  if (
    document.body.dataset.template == "page" &&
    document.body.dataset.suffix == "story"
  ) {
    buildOurStory();
  }
});
